import { useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Ticket, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const promoDiscount = (promo, amount) => {
  if (!promo) return 0;
  if (promo.kind === "percent") return Math.round(amount * promo.value) / 100;
  if (promo.kind === "fixed") return Math.min(promo.value, amount);
  return 0;
};

export default function PromoField({ subtotal, promo, email, scope = "merch", onApply, onClear, testPrefix = "promo" }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const apply = async () => {
    if (!code.trim()) return;
    setBusy(true); setError("");
    try {
      const { data } = await axios.post(`${API}/promo/check`, { code: code.trim(), subtotal, email: email || null, scope });
      if (!data.valid) { setError(data.message || "That code isn't valid."); return; }
      onApply(data);
      setCode("");
    } catch { setError("Couldn't check that code. Try again."); }
    finally { setBusy(false); }
  };

  if (promo) {
    return (
      <div data-testid={`${testPrefix}-applied`} className="flex items-center gap-2 text-xs bg-emerald-50 border-l-2 border-emerald-500 px-2 py-1.5 rounded">
        <Ticket className="w-3.5 h-3.5 text-emerald-700" />
        <span className="font-mono-data font-black text-emerald-800 tracking-wider">{promo.code}</span>
        <span className="text-emerald-700">{promo.label}</span>
        <button type="button" data-testid={`${testPrefix}-remove-btn`} onClick={onClear} className="ml-auto text-zinc-500 hover:text-red-600" aria-label="Remove promo"><X className="w-3.5 h-3.5" /></button>
      </div>
    );
  }
  return (
    <div>
      <div className="flex gap-2">
        <Input data-testid={`${testPrefix}-code-input`} value={code} onChange={(e) => { setCode(e.target.value.toUpperCase()); setError(""); }}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); apply(); } }}
          placeholder="Promo code" className="h-9 text-sm font-mono-data tracking-wider uppercase" />
        <Button type="button" data-testid={`${testPrefix}-apply-btn`} variant="outline" disabled={busy || !code.trim()} onClick={apply} className="h-9 text-xs font-bold">{busy ? "…" : "Apply"}</Button>
      </div>
      {error && <p data-testid={`${testPrefix}-error`} className="text-[11px] text-red-600 mt-1">{error}</p>}
    </div>
  );
}
